import { Link } from 'react-router-dom';
import { Panel, PanelBody, PanelGrid, PanelGridAmount, PanelGridItem, PanelHeader, PanelLink, PanelTitle } from 'components';
import { formatDate } from 'functions';
import { useNavigation } from 'hooks';
import { useUserInfo } from 'state';
import { PaymentDetailHeaderData } from 'types'
import styles from './PaymentDetailHeader.module.scss';

type Props = {
    paymentDetailHeader: PaymentDetailHeaderData
}

export default function PaymentDetailHeader({ paymentDetailHeader }: Props) {
    const { paymentsUrl } = useNavigation();
    const { isInternalUser } = useUserInfo();
    
    return (
        <Panel className={styles.panel}>
            <PanelHeader className={styles.header}>
                <PanelLink>
                    <Link to={paymentsUrl}>Back to Payments</Link>
                </PanelLink>
                <div className={styles.heading}>
                    <PanelTitle>Payment #{paymentDetailHeader.paymentIdRef} | {paymentDetailHeader.vendorId}</PanelTitle>
                </div>
            </PanelHeader>
            <PanelBody className={styles.body}> 
                <PanelGrid>
                    <div className={styles.grid}>
                        {paymentDetailHeader.paymentDate &&
                        <div className={styles.gridItem}>
                            <PanelGridItem
                                label= {"Sent: "}
                                value= {<span> {formatDate(new Date(paymentDetailHeader.paymentDate))}
                                            {isInternalUser && paymentDetailHeader.dotPaymentStatus === 'Voided' && <> &ndash; <strong>Voided</strong></>}
                                        </span>}
                            />
                        </div>
                        }
                        <div className={styles.gridItem}>                            
                            <PanelGridAmount
                                label="Invoiced:"
                                value={paymentDetailHeader.invoicedAmount}
                            />
                        </div>
                        <div className={styles.gridItem}>
                            <PanelGridAmount 
                                label="Cash Discounts:" 
                                value={paymentDetailHeader.discAmount} 
                            />
                        </div>
                        <div className={styles.gridItem}>
                        <PanelGridAmount
                            label="Adjustments:"
                            value={paymentDetailHeader.adjAmount}
                        />
                        </div>
                        <div className={styles.gridItem}>
                            <PanelGridAmount
                                label="Paid:"
                                value={paymentDetailHeader.paidAmount}
                            />
                        </div>
                    </div>
                </PanelGrid>
            </PanelBody>
        </Panel>
    )
}